export const LOAD_PPQ_REPORT = "LOAD_PPQ_REPORT";
export const LOAD_PPQ_REPORT_SUCCESS = "LOAD_PPQ_REPORT_SUCCESS";

export const SENDTOEMPLOYEE_PPQ_CERTIFICATE = "SENDTOEMPLOYEE_PPQ_CERTIFICATE";
export const APPROVE_PPQ_CERTIFICATE = "APPROVE_PPQ_CERTIFICATE";
export const REQUEST_CHANGES_PPQ_CERTIFICATE = "REQUEST_CHANGES_PPQ_CERTIFICATE";
export const REJECT_PPQ_CERTIFICATE = "REJECT_PPQ_CERTIFICATE";

export const SENDTOEMPLOYEE_PPQ_CERTIFICATE_SUCCESS = "SENDTOEMPLOYEE_PPQ_CERTIFICATE_SUCCESS";
export const APPROVE_PPQ_CERTIFICATE_SUCCESS = "APPROVE_PPQ_CERTIFICATE_SUCCESS";
export const REQUEST_CHANGES_PPQ_CERTIFICATE_SUCCESS = "REQUEST_CHANGES_PPQ_CERTIFICATE_SUCCESS";
export const REJECT_PPQ_CERTIFICATE_SUCCESS = "REJECT_PPQ_CERTIFICATE_SUCCESS";
